import { DatePipe } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { ErrorResponseMessage } from 'src/app/error-handler/error-response-message.model';
import { Buttons } from 'src/app/home/table/Buttons';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { CallDetails } from 'src/app/models/commission/call-details.model';
import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';
import { UserManagementModel } from 'src/app/models/userManagementModel/usermang.model';
import { CommissionService } from 'src/app/service/commission.service';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { GlobalService } from 'src/app/service/global.service';
import { KomFeedService } from 'src/app/service/komfeed.service';
import { NotificationService } from 'src/app/service/notification.service';

@Component({
  selector: 'app-kom-call-data',
  templateUrl: './kom-call-data.component.html',
  styleUrls: ['./kom-call-data.component.css']
})
export class KomCallDataComponent implements OnInit {

  callDetailMdl = new CallDetails();
  editCallDetailMdl = new CallDetails();
  columnsData: any;
  dataForExcel = [];
  columnsExcelData: any;
  ordersTableExcelHeaderColumns: TableColumn[];
  ordersTableColumns: TableColumn[];
  resHeadder: string = 'Search Results';
  actions: any;
  actionButtons: any;
  buttons: Buttons[] = [];
  feedResultsData: CallDetails[] = [];
  IsmodelShow: boolean = false;
  slectedCallDetailMdl: CallDetails[] = [];
  isAccessDisabled: boolean = false;

  menusFilter: UserManagementModel[] = [];
  isView: boolean = true;
  permissionCheck: any;
  errorMessage: string;

  constructor(private komFeedService: KomFeedService, private commissionService: CommissionService, private router: Router,
    private notificationService: NotificationService, private httpService: HttpClient,
    private exportExcelService: ExportExcelService, private globalService: GlobalService) { }

  ngOnInit(): void {
    this.init();
    this.isAccessDisabled = this.globalService._permissionCheck('comm-plan');
    if (this.isAccessDisabled)
      this.notificationService.notify(NotificationType.WARNING, "Edit Permission Has Disabled Please Contact To Adminstrator");

  }

  private _normalizeValue(value: string): string {
    return value.toLowerCase().replace(/\s/g, '');
  }

  init() {

    this.komFeedService.getCallDataResult(this.commissionService.callDetailModel).
      subscribe((data: CallDetails[]) => {
        if (data?.length > 0) {
          this.feedResultsData = data;
        }
        else
          this.notificationService.sendNotification(NotificationType.WARNING,
            'Records are not existing');
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });

    this.initializeColumns();
    this.initializeExcelHeaders();
  }

  innerRowAction1(row: any) {
    console.log(row);
    if (!this.isAccessDisabled) {
      if (row.value === 'Delete') {
        this.IsmodelShow = false;
        if (confirm("Are you sure to delete this Record")) {
          this.komFeedService.deleteCallByKomCallID(row.row.kom_call_id).subscribe(
            (response: CustomHttpRespone) => {
              this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
              this.init();
            }, (errorResponse: HttpErrorResponse) => {
              var msg: any;
              msg = errorResponse;
              this.notificationService.sendNotification(NotificationType.ERROR, msg);
            }
          )
        }
      } else if (row.value === 'Update') {
        this.editCallDetailMdl = row.row;
        document.getElementById("Edit").click();

      }
    } else {
      this.errorMessage = 'Edit Permission has Disabled Please Contact Admin';
    }
  }

  redirect(url: string) {
    this.router.navigate(['/' + url]);
  }

  actionOnButton(action: any) {
    if (action === "Add New") {
      if (this.slectedCallDetailMdl.length > 1) {
        this.notificationService.notify(NotificationType.ERROR, "Please select only one row");
      }
      else if (!this.isAccessDisabled) {
        this.IsmodelShow = false;;
        document.getElementById(action).click();
      } else {
        this.errorMessage = 'Edit Permission has Disabled Please Contact Admin';
      }
    }
  }

  public saveNewRecord(kpiForm: NgForm): void {

    this.komFeedService.saveCallDtl(this.callDetailMdl).subscribe((data: CallDetails) => {
      this.close(kpiForm, 'closeCallDtlButton');
      this.init()
    }, (errorResponse: HttpErrorResponse) => {
      var msg: any;
      msg = errorResponse;
      this.notificationService.sendNotification(NotificationType.ERROR, msg);
    });
  }

  onCheck(user: any, values: any) {
    console.log('value ', user);
    // Order = order.row;
    if (values.value.currentTarget.checked) {
      // user.row.edit =true;
      this.slectedCallDetailMdl.push(user.row);

    } else {
      this.slectedCallDetailMdl.forEach((value: any, index: any) => {
        if (value.kom_call_id == user.row.kom_call_id) this.slectedCallDetailMdl.splice(index, 1);
      });
      // user.row.edit =false;
    }
    console.log('value ', this.slectedCallDetailMdl);
    this.callDetailMdl = JSON.parse(JSON.stringify(this.slectedCallDetailMdl[0]));

  }

  close(kpiForm: NgForm, id: string) {
    console.log('======', kpiForm);
    kpiForm.reset();
    document.getElementById(id).click();
  }

  exportExcel() {

  }

  editRecord(kpiForm: NgForm) {
    this.komFeedService.updateCallDtls(this.editCallDetailMdl)
      .subscribe(response => {
        //response = response as ErrorResponseMessage;
        if (response) {
          this.notificationService.sendNotification(NotificationType.SUCCESS,
            `CommissionPlan Updated successfully`);
          this.close(kpiForm, 'closeEditCallDtlButton');
          this.init();

        }
        else
          this.notificationService.sendNotification(NotificationType.ERROR, 'Some Issue Occured');
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      })
    this.close(kpiForm, 'closeAddKPIButton');
  }

  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns = this.columnsData.KomCallData;
        console.log(this.ordersTableColumns);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
    this.actions = [
      {
        name: 'Delete',
        dataKey: 'far fa-trash-alt danger f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-danger'
      },
      {
        name: 'Update',
        dataKey: 'far fa-edit success f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-success'
      }
    ]

    this.actionButtons = [
      {
        name: 'Add New',
        class: 'btn btn-default btn-xs'
      }
    ]
    this.buttons = [

      {
        name: 'Back',
        pagenavigation: 'adjustments-feed'
      }
    ]
  }

  initializeExcelHeaders(): void {
    this.httpService.get('../../../assets/json/excelHeaders.json').subscribe(
      data => {
        this.columnsExcelData = data;
        this.ordersTableExcelHeaderColumns = this.columnsExcelData.FeedResults;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }
}
